function createEmptyItem (options) {
	return options.placeholderText || '';
}

module.exports = createEmptyItem;